module.exports = __webpack_public_path__ + "img/151.0d1661fc.jpg";